import { type ComponentPropsWithoutRef, memo } from 'react';

import { type TagListResponse } from '@air/api/types';
import { Chip } from '@air/primitive-chip';
import { cn } from '@air/utils-tailwind';

export type PopularTagsProps = Pick<ComponentPropsWithoutRef<'div'>, 'className'> & {
  onTagClick: (tag: TagListResponse) => void;
  tags: TagListResponse[];
};

export const PopularTags = memo(({ className, onTagClick, tags }: PopularTagsProps) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <h3 className="font-bold ads:text-metadata text-10 text-gray-9 uppercase tracking-wider">Popular Tags</h3>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <Chip
            asChild
            key={tag.id}
            // biome-ignore lint/performance/noJsxPropsBind: each chip clicks the tag object for that row
            onClick={() => onTagClick(tag)}
            shape="rounded"
            size="medium"
          >
            <button type="button">{tag.label}</button>
          </Chip>
        ))}
      </div>
    </div>
  );
});

PopularTags.displayName = 'PopularTags';
